import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { RemoveCustomerModal } from "@features/RemoveCustomerModal/RemoveCustomerModal";
import { Button } from "@components/Button";
import { ExclamationCircleIcon } from "@components/icons";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { useModalStore, type IUseModalProps } from "@store/modal/modal";

export const ServiceRefusalModal: React.FC<IUseModalProps> = (props) => {
  const modal = useModal(props);
  const { create } = useModalStore();
  const { t } = useTranslation();

  return (
    <Modal
      modal={modal}
      badgeProps={{ icon: ExclamationCircleIcon, color: "red" }}
      actionButtons={
        <React.Fragment>
          <Button variant="secondary" onClick={modal.close} className="w-full">
            {t("addHouseModal.buttons.cancel")}
          </Button>
          <Button
            onClick={() => {
              create((modalProps) => <RemoveCustomerModal {...modalProps} />);
              modal.close();
            }}
            className="w-full"
          >
            {t("serviceRefusalModal.submit")}
          </Button>
        </React.Fragment>
      }
      title={t("serviceRefusalModal.title")}
      className="md:max-w-xl"
    >
      <p>{t(`serviceRefusalModal.firstParagaph`)}</p>
      <p>
        <Link to={t(`formAgreementInput.fields.privacyPolicy.link`)}>
          {t(`serviceRefusalModal.privacyPolicy`)}
        </Link>
      </p>
      <p>
        <Link to={t(`formAgreementInput.fields.terms.link`)}>
          {t(`serviceRefusalModal.termsOfService`)}
        </Link>
      </p>
      <br />
      <p>{t(`serviceRefusalModal.secondParagraph`)}</p>
    </Modal>
  );
};
